module.exports = __webpack_public_path__ + "img/caoping.1ef53529.png";